import Button from '@/components/Button';
import { Body, Small } from '@/components/Typography';
import styled from '@/styles';

const Box = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '20px',
});

const Skeleton = styled('div', {
  backgroundColor: '#EDEDED',
  borderRadius: '6px',
  height: '14px',
});

type Props = {
  mode: 'loading' | 'error' | 'empty';
  title?: string;
  caption?: string;
  error?: string;
  onRetry?: () => void;
};

const SectionState = ({ mode, title, caption, error, onRetry }: Props) => {
  if (mode === 'loading') {
    return (
      <Box
        aria-busy="true"
        aria-label={title ? `Loading ${title}` : 'Loading'}
        css={{ alignItems: 'stretch' }}
      >
        <Skeleton css={{ width: '40%', height: '18px' }} />
        <Skeleton css={{ width: '75%' }} />
        <Skeleton css={{ width: '55%' }} />
      </Box>
    );
  }

  if (mode === 'error') {
    return (
      <Box>
        <div role="alert">
          <Body color="danger" weight="medium">
            {error || 'Something went wrong.'}
          </Body>
        </div>
        {onRetry && (
          <Button
            a11yLabel="Try again"
            label="Try again"
            appearance="outline"
            size="sm"
            onClick={onRetry}
          />
        )}
      </Box>
    );
  }

  return (
    <Box css={{ gap: '4px' }}>
      {title && <Body weight="medium">{title}</Body>}
      {caption && <Small color="light">{caption}</Small>}
    </Box>
  );
};

export default SectionState;
